<template>
  <div>
    <div class="grid-view">
      <div class="main-content">
        <div class="app-main-inner-row">
          <div class="filters">
            <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')" class="el-form-item-w250">
                  <el-select v-model="searchConditions.jobType" no="searchJobType" @change="handleTypeChange(true)">
                    <el-option
                      v-for="item in types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_BusinessModel')" class="el-form-item-w250">
                  <el-select v-model="searchConditions.containerLoadType" no="searchContainerLoadType" :clearable="true" @change="handleContainerLoadTypeChange(true)">
                    <el-option
                      v-for="(item,index) in containerLoadType.SI"
                      v-show="searchConditions.jobType==='SI'"
                      :key="'SI'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                    <el-option
                      v-for="(item,index) in containerLoadType.AE"
                      v-show="searchConditions.jobType==='AE'"
                      :key="'AE'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                    <el-option
                      v-for="(item,index) in containerLoadType.AI"
                      v-show="searchConditions.jobType==='AI'"
                      :key="'AI'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                    <el-option
                      v-for="(item,index) in containerLoadType.default"
                      v-show="searchConditions.jobType==='SE'||searchConditions.jobType==='RE'||searchConditions.jobType==='RI'"
                      :key="'default'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                    <el-option
                      v-for="(item,index) in containerLoadType.IE"
                      v-show="searchConditions.jobType==='IE'"
                      :key="'IE'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_CustomJobType')" class="el-form-item-w320">
                  <cargo-advance-select
                    no="searchCustomJobType"
                    :select-type="selectTypeNames.basic_data_CutomJobType"
                    :multiple="true"
                    :clearable="false"
                    filterable
                    :method-params="{type:searchConditions.jobType, grade: 0, active: true}"
                    :default-multiple-value="searchConditions.customJobType"
                    tag-value="code"
                    :tag-name="isZh?'name':'englishName'"
                    :cache="false"
                    :static-options="searchCustomJobTypeList"
                    :placeholder="' '"
                    @parentCallBack="p=>{searchConditions.customJobType=p.value;}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_OperationOffice')" class="el-form-item-w320">
                  <cargo-advance-select
                    no="searchBranchId"
                    :select-type="selectTypeNames.basic_data_Office"
                    :multiple="true"
                    :clearable="false"
                    filterable
                    :default-multiple-value="searchConditions.branchId"
                    tag-value="officeId"
                    tag-name="code"
                    :filter-tag-names="['englishName','chineseName','code']"
                    :cache="false"
                    :static-options="officeList"
                    :placeholder="' '"
                    @parentCallBack="p=>{searchConditions.branchId=p.value;}"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="triggers">
            <el-button type="primary" size="mini" @click="toQuery">{{ $t('common.btn.query') }}</el-button>
            <el-button type="primary" size="mini" @click="popMappingAddDialog">{{ $t('common.btn.new') }}</el-button>
            <el-button type="primary" size="mini" @click="popMappingEditFormDialog">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="danger" size="mini" @click="toBatchDel">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-options="gridOptions"
            :side-bar="sideBarDefs"
            style="width: 100%;"
          />
        </div>
        <div>
          <cargo-pagination
            config-module="260310"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchData"
          />
        </div>
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowDialogForm"
      :title="dialogTitle"
      width="880px"
      custom-class="automatic-allocation-config-dialog"
    >
      <div class="details-view">
        <div class="main-content">
          <el-form ref="mappingForm" :inline="true" :model="mappingForm" label-width="100px" label-position="right">
            <div class="section">
              <span class="title" style="padding-top: 5px;">{{ this.$t('CargoMsg.Cargo_MatchingCriteriaSelection') }}</span>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('CargoMsg.Cargo_OperationOffice')" class="el-form-item-w320">
                  <cargo-advance-select
                    no="branchId"
                    :select-type="selectTypeNames.basic_data_Office"
                    :multiple="true"
                    :clearable="false"
                    filterable
                    :default-multiple-value="mappingForm.branchIdList"
                    tag-value="officeId"
                    tag-name="code"
                    :filter-tag-names="['englishName','chineseName','code']"
                    :cache="false"
                    :static-options="officeList"
                    :placeholder="' '"
                    @parentCallBack="p=>{mappingForm.branchIdList=p.value;}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')" class="el-form-item-w250">
                  <el-select v-model="mappingForm.lob" no="type" @change="handleTypeChange(false)">
                    <el-option
                      v-for="item in types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_BusinessModel')" class="el-form-item-w250">
                  <el-select v-model="mappingForm.containerLoadType" no="containerLoadType" :clearable="true" @change="handleContainerLoadTypeChange(false)">
                    <el-option
                      v-for="(item,index) in containerLoadType.SI"
                      v-show="mappingForm.lob==='SI'"
                      :key="'SI'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                    <el-option
                      v-for="(item,index) in containerLoadType.AE"
                      v-show="mappingForm.lob==='AE'"
                      :key="'AE'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                    <el-option
                      v-for="(item,index) in containerLoadType.AI"
                      v-show="mappingForm.lob==='AI'"
                      :key="'AI'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                    <el-option
                      v-for="(item,index) in containerLoadType.default"
                      v-show="mappingForm.lob==='SE'||mappingForm.lob==='RE'||mappingForm.lob==='RI'"
                      :key="'default'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                    <el-option
                      v-for="(item,index) in containerLoadType.IE"
                      v-show="mappingForm.lob==='IE'"
                      :key="'IE'+index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('CargoMsg.Cargo_CustomJobType')" class="el-form-item-w320">
                  <cargo-advance-select
                    no="customJobType"
                    :select-type="selectTypeNames.basic_data_CutomJobType"
                    :multiple="true"
                    :clearable="false"
                    filterable
                    :method-params="{type:mappingForm.lob, grade: 0, active: true}"
                    :default-multiple-value="mappingForm.customJobTypeList"
                    tag-value="code"
                    :tag-name="isZh?'name':'englishName'"
                    :cache="false"
                    :static-options="customJobTypeList"
                    :placeholder="' '"
                    @parentCallBack="p=>{mappingForm.customJobTypeList=p.value;}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_OperateBy')" class="el-form-item-w500">
                  <cargo-advance-select
                    no="opId"
                    :select-type="selectTypeNames.static_data_User"
                    :multiple="true"
                    :clearable="true"
                    filterable
                    :method-params="{category:'role',shape:'op'}"
                    :default-multiple-value="mappingForm.opIdList"
                    tag-value="userId"
                    tag-name="chineseName"
                    :filter-tag-names="['englishName','chineseName','userCode']"
                    :cache="false"
                    :static-options="userList"
                    :placeholder="' '"
                    @parentCallBack="p=>{mappingForm.opIdList=p.value;}"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="section">
              <div style="display: flex;">
                <span class="title" style="padding-top: 5px; padding-right: 20px;">{{ this.$t('CargoMsg.Cargo_AutomaticAllocationRuleConfig') }}</span>
                <el-form-item label-width="0">
                  <el-radio-group v-model="mappingForm.enabled" no="enabled">
                    <el-radio :label="true">{{ $t('Message.Open') }}</el-radio>
                    <el-radio :label="false">{{ $t('Message.Close') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div style="display: flex;">
                <el-form-item :label="$t('CargoMsg.Cargo_AllocationNature')">
                  <el-radio-group v-model="mappingForm.allocationNature" no="allocationNature">
                    <el-radio :label="0">{{ $t('Message.VirtualAllocation') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_HblSingleAllocation')">
                  <el-checkbox v-model="mappingForm.onlyJoinFlagHBL" no="onlyJoinFlagHBL">{{ this.$t('CargoMsg.Cargo_OnlyAllocatedToHblSingle') }}</el-checkbox>
                </el-form-item>
              </div>
              <el-card :header="$t('CargoMsg.Cargo_MasterBill')" shadow="always">
                <cargo-ag-grid
                  :show-side-bar="false"
                  :grid-options="costTable.grid.gridOptions"
                  :column-defs="dynamicCostColumnDefs"
                  :row-data="mappingForm.details"
                  min-height="200px"
                  @gridReady="params=>{costTable.grid.gridApi=params.api}"
                />
              </el-card>

            </div>
            <div class="section">
              <el-form-item :label="$t('CargoMsg.Cargo_RemarksInfo')" class="el-form-item-textarea-label100">
                <el-input v-model="mappingForm.remark" no="remark" type="textarea" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submit">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="isShowDialogForm=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>

import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import { getLoading } from '@/utils/utilBaseElement'
import { getAllocationConfigList, saveAllocationConfig, delAllocationConfig } from '@/api/sysManage/baseConfig/automaticAllocationConfig'
import { Assert } from '@/utils/validate'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { User } from '@/class/model/sys/User'
import { SHARE_CHARGE_SCHEMES_NEW } from '@/class/cargo/model/parameters/ChargeConstants'
import { deepClone } from '@/utils'
import * as commonUtil from '@/utils/commonUtil'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'

export default {
  name: 'AutomaticAllocationConfig',
  components: {

    cargoAdvanceSelect
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      loading: null,
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_OperationOffice'), field: 'branchIds', initialWidth: 180, minWidth: 180,
          cellRenderer: (params) => {
            return ColumnUtils.branchIdsLabelFunction(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'lob', initialWidth: 100, minWidth: 100,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessModel'), field: 'containerLoadType', initialWidth: 100, minWidth: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          filter: false, filterParams: {}
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomJobType'), field: 'customJobType', initialWidth: 180, minWidth: 180,
          cellRenderer: (params) => {
            // return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
            return ColumnUtils.customJobTypeLabelFunction(params.data, 'customJobType')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AllocationNature'), field: 'allocationNature', initialWidth: 120, minWidth: 120,
          valueFormatter: params => {
            return ColumnUtils.allocationNatureFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', initialWidth: 200, minWidth: 200 },
        { headerName: this.$t('CargoMsg.Cargo_EnableStatus'), field: 'enabled', initialWidth: 100, minWidth: 100, cellStyle: { textAlign: 'center' },
          cellRenderer: params => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        paginationNumberFormatter: function(params) {
          return '[' + params.value.toLocaleString() + ']'
        }
      },
      gridApi: null,
      searchConditions: {
        jobType: '', // 业务类型
        containerLoadType: '', // 业务模式
        customJobType: [], // 自定义业务类型
        branchId: [], // 操作分公司
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      initMappingForm: {
      },
      mappingForm: {
        uuid: '',
        branchIds: '', // 操作分公司ID
        branchIdList: [], // 操作分公司ID
        lob: '', // 业务类型
        containerLoadType: '', // 业务模式
        customJobType: '', // 自定义业务类型
        customJobTypeList: [], // 自定义业务类型
        enabled: true, // 是否开启
        allocationNature: 0, // 分摊性质
        onlyJoinFlagHBL: true, // 仅分摊到并单上
        remark: '', // 备注信息
        opIds: '', // 操作人
        opIdList: [], // 操作人
        details: [] // 费用名称列表
      },
      isShowDialogForm: false,
      officeList: [], // 分公司列表
      types: [], // 业务类型
      containerLoadType: { // 业务模式
        SI: [],
        AE: [],
        AI: [],
        IE: [],
        default: []
      },
      searchCustomJobTypeList: [],
      customJobTypeList: [],
      userList: [], // 人员列表
      documentManage: new commonUtil.DocumentManage(),
      costTable: {
        grid: {
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            suppressContextMenu: true,
            suppressClipboardPaste: true,
            suppressRowClickSelection: false,
            singleClickEdit: true,
            frameworkComponents: {
              CargoAgGridAdvanceSelectEditor,
              CargoAgGridSelectEditor
            },
            context: {
              componentParent: this
            },
            defaultColDef: {
              sortable: false,
              resizable: false,
              menuTabs: []
            }
          },
          gridApi: null
        }
      }
    }
  },
  computed: {
    url() {
      return URL
    },
    dialogTitle() {
      if (this.mappingForm.uuid) {
        return this.$t('CargoMsg.Cargo_EditAutomaticAllocationConfig')
      }
      return this.$t('CargoMsg.Cargo_AddAutomaticAllocationConfig')
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    dynamicCostColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_SequenceNumber'), field: 'seqNo', initialWidth: 80, minWidth: 80, sortable: false, cellStyle: { textAlign: 'center' }},
        { headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', initialWidth: 180, minWidth: 180, lockVisible: true,
          headerClass: 'ag-header-cell-left', cellStyle: { textAlign: 'left' },
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_ChargeItem,
              methodParams: this.getChargeItemFilter(true),
              tagValue: 'itemId',
              tagName: this.isZh ? 'zhName' : 'enName',
              filterable: true,
              showCustomLabelInOption: true
            },
            isZero: true
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('FinanceManage.allocationType'), field: 'shareScheme', initialWidth: 150, minWidth: 150, lockVisible: true,
          headerClass: 'ag-header-cell-left', cellStyle: { textAlign: 'left' },
          valueFormatter: params => {
            return params.value === '' ? '' : ColumnUtils.shareSchemeFunc(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: SHARE_CHARGE_SCHEMES_NEW,
            tagName: 'chineseName',
            tagValue: 'code'
          }
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'operation', initialWidth: 80, minWidth: 80, suppressMenu: true,
          cellRenderer: params => {
            const onAdd = this.documentManage.getPath('onAdd')
            const onDel = this.documentManage.getPath('onDel')
            return `<div><a onclick="${onAdd}()" style="color:#1F75D5;font-size:25px;padding-left: 10px;">+</a><a onclick="${onDel}(${params.data.seqNo})" style="color:#1F75D5;font-size:25px;padding-left: 10px;">-</a></div>`
          }
        }
      ]
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initMappingForm = { ...this.mappingForm }
    // 分公司列表
    this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
    this.officeList = this.officeList.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId - office2.officeId)
    // 业务类型列表
    this.types.push({ label: this.$t('constant.systemConstants.SE'), value: 'SE' })
    this.types.push({ label: this.$t('constant.systemConstants.SI'), value: 'SI' })
    this.types.push({ label: this.$t('constant.systemConstants.AE'), value: 'AE' })
    this.types.push({ label: this.$t('constant.systemConstants.AI'), value: 'AI' })
    this.types.push({ label: this.$t('constant.systemConstants.RE'), value: 'RE' })
    this.types.push({ label: this.$t('constant.systemConstants.RI'), value: 'RI' })
    this.types.push({ label: this.$t('constant.systemConstants.IE'), value: 'IE' })
    // SI
    this.containerLoadType.SI.push({ label: this.$t('constant.importConstants.FCL'), value: 'FCL' })
    this.containerLoadType.SI.push({ label: this.$t('constant.importConstants.LCL'), value: 'LCL' })
    this.containerLoadType.SI.push({ label: this.$t('constant.importConstants.CON'), value: 'CON' })
    this.containerLoadType.SI.push({ label: this.$t('constant.importConstants.POJ'), value: 'POJ' })
    this.containerLoadType.SI.push({ label: this.$t('constant.importConstants.PVE'), value: 'PVE' })
    this.containerLoadType.SI.push({ label: this.$t('constant.importConstants.ECL'), value: 'ECL' })
    this.containerLoadType.SI.push({ label: this.$t('constant.importConstants.BULK'), value: 'BULK' })
    // AE
    this.containerLoadType.AE.push({ label: this.$t('constant.airExportConstants.CONSOLE'), value: 0 })
    this.containerLoadType.AE.push({ label: this.$t('constant.airExportConstants.DIRECT'), value: 2 })
    this.containerLoadType.AE.push({ label: this.$t('constant.airExportConstants.BACK_TO_BACK'), value: 3 })
    // AI
    this.containerLoadType.AI.push({ label: this.$t('constant.importConstants.CONSOLE'), value: 0 })
    this.containerLoadType.AI.push({ label: this.$t('constant.importConstants.DIRECT'), value: 1 })
    this.containerLoadType.AI.push({ label: this.$t('constant.importConstants.BACK_TO_BACK'), value: 2 })
    // IE
    this.containerLoadType.IE.push({ label: this.$t('CargoMsg.Cargo_TruckTrailer'), value: 'TT' })
    this.containerLoadType.IE.push({ label: this.$t('CargoMsg.Cargo_WholeVehicleAndLessThanCarload'), value: 'CL' })
    // CARGO-40378 当新增/编辑 自定义业务类型时，选择【业务类型】为【综合物流】。业务模式增加【国际卡航】
    this.containerLoadType.IE.push({ label: this.$t('CargoMsg.Cargo_IC'), value: 'IC' })
    // deault(SE、RE)：参照ColumnUtils.containerLoadTypeLabelFunction
    this.containerLoadType.default.push({ label: this.isZh ? ContainerLoadType.FCL_CARGO_TYPE.chineseName : ContainerLoadType.FCL_CARGO_TYPE.englishName, value: 'FCL' })
    this.containerLoadType.default.push({ label: this.isZh ? ContainerLoadType.LCL_CARGO_TYPE.chineseName : ContainerLoadType.LCL_CARGO_TYPE.englishName, value: 'LCL' })
    this.containerLoadType.default.push({ label: this.isZh ? ContainerLoadType.BB_CARGO_TYPE.chineseName : ContainerLoadType.BB_CARGO_TYPE.englishName, value: 'BB' })
    this.containerLoadType.default.push({ label: this.isZh ? ContainerLoadType.BC_CARGO_TYPE.chineseName : ContainerLoadType.BC_CARGO_TYPE.englishName, value: 'BC' })
    this.containerLoadType.default.push({ label: this.isZh ? ContainerLoadType.BULK_CARGO_TYPE.chineseName : ContainerLoadType.BULK_CARGO_TYPE.englishName, value: 'BULK' })
    this.containerLoadType.default.push({ label: this.isZh ? ContainerLoadType.SPECIAL_CARGO_TYPE.chineseName : ContainerLoadType.SPECIAL_CARGO_TYPE.englishName, value: 'SPA' })
    this.containerLoadType.default.push({ label: this.isZh ? ContainerLoadType.BC_CARGO_TYPE_FCL.chineseName : ContainerLoadType.BC_CARGO_TYPE_FCL.englishName, value: 'BCF' })
    // 操作列表
    this.userList = await User.getUsersByPrivilegeDetail('role', 'op', null, null, true)
    this.userList.sort((user1, user2) => user1.userId - user2.userId)
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onAdd', function() {
      context.onAdd()
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  mounted() {
    this.toQuery()
  },
  methods: {
    initDetail() {
      if (!this.mappingForm.details || this.mappingForm.details.length === 0) {
        this.mappingForm.details = []
        this.onAdd()
      } else {
        this.addSeqNo(this.mappingForm.details)
      }
    },
    toQuery() {
      this.searchConditions.pageNum = 1
      this.searchConditions.total = 0
      this.fetchData()
    },
    fetchData() {
      this.loading = getLoading()
      const params = { ...this.searchConditions }
      getAllocationConfigList(params).then((res) => {
        this.rowData = res.data.list
        this.searchConditions.total = res.data.total ? Number(res.data.total) : 0
      }).finally(() => {
        this.loading.close()
      })
    },
    popMappingAddDialog() {
      this.isShowDialogForm = true
      this.mappingForm = { ...this.initMappingForm }
      this.mappingForm.lob = 'SE'
      this.initDetail()
      this.handleTypeChange()
    },
    async popMappingEditFormDialog() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.mappingForm = deepClone(selectedRow)
      this.initDetail()
      // 操作分公司
      this.mappingForm.branchIdList = commonUtil.split(this.mappingForm.branchIds, ',', true)
      // 操作人
      this.mappingForm.opIdList = commonUtil.split(this.mappingForm.opIds, ',', true)
      // 自定义业务类型
      this.mappingForm.customJobTypeList = commonUtil.split(this.mappingForm.customJobType, ',', false)
      this.initCustomJobTypeList()
      // 显示编辑弹窗
      this.isShowDialogForm = true
    },
    async toBatchDel() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // 表格单选，删除一条
      await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmDeleteTheConfigItem'), this.$t('common.tips.confirm'), { type: 'warning' })
      this.loading = getLoading()
      delAllocationConfig([selectedRow.uuid]).then(async() => {
        await this.fetchData()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 新增
    onAdd() {
      const newConfiguration = {
        type: 1,
        configUuid: '',
        seqNo: this.mappingForm.details.length + 1, // 序号
        chargeItemId: 0, // 费用名称ID
        shareScheme: '' // 分摊类型
      }
      this.mappingForm.details.push(newConfiguration)
      this.addSeqNo(this.mappingForm.details)
    },
    // 删除
    onDel(seqNo) {
      this.mappingForm.details = this.mappingForm.details.filter(row => row.seqNo !== seqNo)
      if (this.mappingForm.details.length === 0) {
        this.initDetail()
      } else {
        this.addSeqNo(this.mappingForm.details)
      }
    },
    // 检查
    async toCheckForm() {
      await Assert.isNotBlank(this.mappingForm.lob, this.$t('CargoMsg.Cargo_BusinessTypeCanTBeEmpty'), 'warning')
      for (const detail of this.mappingForm.details) {
        await Assert.isFalsy(!detail.chargeItemId && detail.shareScheme === '', this.$t('CargoMsg.Cargo_PleaseSetChargeNameAndAllocationType'), 'warning')
        await Assert.isFalsy(!detail.chargeItemId, this.$t('CargoMsg.Cargo_PleaseSetChargeName'), 'warning')
        await Assert.isFalsy(detail.shareScheme === '', this.$t('CargoMsg.Cargo_PleaseSetAllocationType'), 'warning')
      }
      let sameRowData = []
      await getAllocationConfigList({ 'jobType': this.mappingForm.lob, 'pageNum': 1, 'pageSize': 100 }).then((res) => {
        sameRowData = res.data.list
      })
      // 匹配条件唯一性校验：操作分公司+业务类型+业务模式+自定义业务类型 唯一
      for (const row of sameRowData) {
        if (this.mappingForm.uuid === row.uuid) {
          continue
        }
        const existed = this.hasExisted(this.mappingForm.lob, row.lob) && // 业务类型
          this.hasExisted(this.mappingForm.containerLoadType, row.containerLoadType) && // 业务模式
          this.hasMixed(this.mappingForm.branchIds, row.branchIds) && // 操作分公司
          this.hasMixed(this.mappingForm.customJobType, row.customJobType) // 自定义业务类型
        await Assert.isFalsy(existed, this.$t('CargoMsg.Cargo_HasDuplicateConfigItem'), 'warning')
      }
    },
    async submit() {
      // 操作分公司
      if (this.mappingForm.branchIdList) {
        let text = ''
        for (const data of this.mappingForm.branchIdList) {
          if (text.length !== 0) {
            text = text + ','
          }
          text = text + data
        }
        this.mappingForm.branchIds = text
      } else {
        this.mappingForm.branchIds = ''
      }
      // 操作人
      if (this.mappingForm.opIdList) {
        let text = ''
        for (const data of this.mappingForm.opIdList) {
          if (text.length !== 0) {
            text = text + ','
          }
          text = text + data
        }
        this.mappingForm.opIds = text
      } else {
        this.mappingForm.opIds = ''
      }
      // 自定义业务类型
      if (this.mappingForm.customJobTypeList) {
        let text = ''
        for (const data of this.mappingForm.customJobTypeList) {
          if (text.length !== 0) {
            text = text + ','
          }
          text = text + data
        }
        this.mappingForm.customJobType = text
      } else {
        this.mappingForm.customJobType = ''
      }
      await this.toCheckForm()
      if (this.mappingForm.uuid) {
        await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmSaveModifiedInfo'), this.$t('common.tips.confirm'), { type: 'warning' })
      }
      this.loading = getLoading()
      saveAllocationConfig(this.mappingForm).then(async() => {
        this.isShowDialogForm = false
        this.fetchData()
      }).finally(() => {
        this.loading.close()
      })
    },
    handleTypeChange(searchFlag = false) {
      if (searchFlag) {
        this.searchConditions.containerLoadType = ''
        this.searchConditions.customJobType = []
      } else {
        this.mappingForm.containerLoadType = ''
        this.mappingForm.customJobType = ''
        this.mappingForm.customJobTypeList = []
      }
      this.initCustomJobTypeList(searchFlag)
    },
    handleContainerLoadTypeChange(searchFlag = false) {
      if (searchFlag) {
        this.searchConditions.customJobType = []
      } else {
        this.mappingForm.customJobType = ''
        this.mappingForm.customJobTypeList = []
      }
      this.initCustomJobTypeList(searchFlag)
    },
    initCustomJobTypeList(searchFlag = false) {
      const jobType = searchFlag ? this.searchConditions.jobType : this.mappingForm.lob
      const containerLoadType = searchFlag ? this.searchConditions.containerLoadType : this.mappingForm.containerLoadType
      // 如果没有业务类型
      if (searchFlag) {
        if (!jobType) {
          this.searchCustomJobTypeList = []
          return
        }
        // 根据业务类型
        this.searchCustomJobTypeList = getCacheListByKey(basicCacheKeys.basic_data_CutomJobType).filter(p => p.grade === 0 && p.active === true && p.type === jobType)
        // 根据业务模式
        if (containerLoadType) {
          this.searchCustomJobTypeList = this.searchCustomJobTypeList.filter(p => p.containerLoadType === containerLoadType)
        }
        // 排序
        this.searchCustomJobTypeList.sort((customJobType1, customJobType2) => customJobType1.code - customJobType2.code)
      } else {
        if (!jobType) {
          this.customJobTypeList = []
          return
        }
        // 根据业务类型
        this.customJobTypeList = getCacheListByKey(basicCacheKeys.basic_data_CutomJobType).filter(p => p.grade === 0 && p.active === true && p.type === jobType)
        // 根据业务模式
        if (containerLoadType) {
          this.customJobTypeList = this.customJobTypeList.filter(p => p.containerLoadType === containerLoadType)
        }
        // 排序
        this.customJobTypeList.sort((customJobType1, customJobType2) => customJobType1.code - customJobType2.code)
      }
    },
    // 费用项目过滤
    getChargeItemFilter(cost) {
      const lob = this.mappingForm.lob
      let filter = {}
      switch (lob) {
        case 'SE':
          filter = { seaExport: true, active: true }
          break
        case 'SI':
          filter = { seaImport: true, active: true }
          break
        case 'AE':
          filter = { airExport: true, active: true }
          break
        case 'AI':
          filter = { airImport: true, active: true }
          break
        case 'RE':
        case 'RI':
          filter = { railwayExport: true, active: true }
          break
        case 'IE':
          filter = { integratedJob: true, active: true }
          break
        default:
      }
      return filter
    },
    // 序号
    addSeqNo(rowData) {
      rowData.forEach((item, index) => {
        item.seqNo = index + 1
      })
    },
    onCellChange(params) {
      // 当用户设置了【费用名称】时，【分摊类型】自动显示默认值【不分摊】
      if (params.colDef.field === 'chargeItemId') {
        if (params.data.chargeItemId && params.data.shareScheme === '') {
          params.data.shareScheme = 0
        } else if (!params.data.chargeItemId && params.data.shareScheme !== '') {
          params.data.shareScheme = ''
        }
        params.node.setDataValue('shareScheme', params.data.shareScheme)
      }
    },
    // 操作分公司、自定义业务类型 是否重复
    hasMixed(currentValue, otherValue) {
      if (currentValue && otherValue) {
        const arr1 = commonUtil.split(currentValue, ',', true)
        const arr2 = commonUtil.split(otherValue, ',', true)
        const set2 = new Set(arr2)
        const mixed = arr1.filter(item => set2.has(item))
        return mixed.length > 0
      } else if (currentValue === '' || otherValue === '') { // 全部
        return true
      }
      return false
    },
    // 业务类型、业务模式 是否重复
    hasExisted(currentValue, otherValue) {
      if (currentValue && otherValue) {
        return currentValue === otherValue
      } else if (currentValue === '' || otherValue === '') { // 全部
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.automatic-allocation-config-dialog {
  .el-dialog__body {
    font-size: 12px;
    padding: 0 !important;
    min-height: 450px;
  }
  .el-form-item-w500 {
    width: 502px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 402px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w320 {
    width: 320px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 220px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w250 {
    width: 250px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 150px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-textarea-label100 {
    width: 820px;
    .el-form-item__label {
      width: 100px !important;
    }
    .el-form-item__content {
      width: 720px;
    }
    .el-textarea__inner {
      padding: 2px 4px !important;
      height: 44px;
      resize: none;
    }
  }
  .el-card {
    margin: 0px 0;
    padding-top: 15px;
    position: relative;
    overflow: unset;
    &__header {
      position: absolute;
      display: inline-block;
      padding: 0 0px;
      margin-left: 10px;
      transform: translateY(-50%);
      border: none;
      background: #fff;
    }
    &__body {
      padding: 15px 5px 5px 5px;
    }
  }
}

</style>
